export default {
  general: {
    labels: {
      status: 'Estatus',
      actions: 'Acciones',
      copied: 'Copiado',
      error: 'Error',
      standard: 'Estándar',
      step: 'Paso',
      steps: 'Pasos',
      times: 'vez o veces',
      table: 'Planilla',
      exporting: 'Exportando',
      your: 'Tu',
      in: 'en',
      date: 'FECHA',
      box_name: 'Nombre del Formulário de Búsqueda',
      new_box: 'Nuevo Formulário de Búsqueda',
      next: 'PRÓXIMO',
      edition: 'Edición',
      editing: 'Editando',
      description: 'Descripción',
      title: 'Título',
      days: 'Días',
      configurations: 'Configuraciones',
      and: 'y',
      seconds: 'Segundos',
      homepage: 'Inicio',
      hotmart_logo: 'Logo de Hotmart',
      themes: 'Modelos',
      saving: 'Salvando',
      jump: 'Salto',
      destinations: 'Destinos',
      first: 'Primero',
      last: 'Último',
      to: 'PARA',
      button: 'Botón',
      external: 'Externo',
      center: 'Centralizado',
      left: 'Izquierda',
      right: 'Derecha',
      other: 'Otro',
      option: 'Opción',
    },
    actions: {
      new: 'NUVEVO FORMULARIO DE BÚSQUEDA',
      delete: 'Eliminar',
      export: 'Exportar',
      report: 'Informe',
      edit: 'Editar',
      copy: 'Copiar',
      close: 'Cerrar',
      cancel: 'Cancelar',
      duplicate: 'Duplicar',
      publish: 'Publicar',
      back: 'Volver',
      click: 'CLIC',
      add: 'ADICIONAR',
    },
  },
  index: {
    title: 'Formularios de Búsqueda',
    subtitle: 'La manera más simple y fácil de crear tus Búsquedas',
    find_a_box: 'Buscar un Formulario de Búsqueda',
    list_header: {
      modality: 'Modalidad',
      last_modification: 'Última Modificación',
    },
  },
  error: {
    oops: 'oops',
    page_not_exists: 'Es posible que esta página no exista...',
    check_url: 'Verifica si la dirección está escrita correctamente o intenta de nuevo más tarde',
    something_wrong: 'Algo parece estar errado...',
    system_offline: 'El sistema puede estar no disponible. ',
    our_devs: 'Pero nuestros técnicos ya están dedicados a resolver este problema. ',
    try_again_later: 'Intenta de nuevo en instantes',
  },
  modal: {
    cant_export_table: {
      title: 'No es posible explorar este informe',
      max_limit: 'Limite máximo para  de exploración de resultados son de ',
      select_interval: ' respuestas. Por favor, selecciona un periodo de fechas menor',
    },
    code: {
      step_one: 'Copia el código del Formulario de Búsqueda abajo y pégalo en tu página',
      step_two: 'Copia el código del botón de llamada aquí abajo ',
      step_three: 'y añade el link o botón que abrirá el Formulario de Búsqueda',
    },
    delete_box: {
      are_you_sure: '¿Deseas realmente eliminar este Formulario de Búsqueda?',
      yes: 'Sí, quiero eliminar este Formulario de Búsqueda',
    },
    delete_step: {
      are_you_sure: '¿Deseas realmente eliminar este paso?',
      yes: 'Sí, quiero eliminar este paso',
    },
    duplicate_step: {
      are_you_sure: '¿Deseas realmente duplicar este paso?',
      yes: 'Sí, quiero duplicar este paso',
    },
    export_table: {
      answer_table: 'Tabla de respuestas',
      insert: 'Ingresa aquí abajo tu email para que te enviemos la tabla de respuestas '
        + 'cuando esté lista',
    },
    export_table_in_progress: {
      processing_request: 'solicitación está siendo procesada',
      send_email: 'y así que esté finalizada seráenviada para el e-mail',
      some_hours: 'Este proceso puede llevar algunas horas',
    },
  },
  report: {
    menu: {
      report_of: 'Report de',
      back_to_answers_summary: 'Regresar para resumen de respuestas',
      metrics: 'Métricas',
      individual_answers: 'Respuestas Individuales',
      box_options: 'Opciones de Formulario de Búsqueda',
    },
    charts: {
      total_answers: 'Total de respuestas',
    },
    individual: {
      date_filter: 'FILTRAR POR PERIODO',
      date_range: 'PERIODO',
      from: 'De',
      to: 'a',
      answered_in: 'Respondido en',
      obtained_answers: 'respuestas obtenidas',
    },
    metrics: {
      total_visits: 'VISITAS TOTALES',
      visits_without_answers: 'VISITAS SIN RESPUESTAS',
      quizzes_not_completed: 'QUIZZES NO CONCLUIDOS',
      quizzes_completed: 'QUIZZES CONCLUIDOS',
      completion_rate: 'TASA DE CONCLUSIÓN',
      average_time_to_complete: 'TIEMPO MEDIO PARA CONCLUIR',
      desktop: 'PCs & LAPTOPS',
      tablet: 'tablet',
      mobile: 'teléfono móvil',
      others: 'otros',
    },
    emails: {
      captured_emails: 'e-mails capturados',
      who_answered: 'de quien respondió',
    },
    resume: {
      question_not_answered: 'Esta pregunta aún no ha sido respondida',
      no_information_found: 'Ninguna información encontrada',
    },
  },
  edit: {
    canvas: {
      visualizing: 'Visualizando',
      active_item: 'Ítem Activo',
      default_item: 'Ítem Estándar',
      past_item: 'Ítem pasado',
      progressbar: 'Barra de Progreso',
      general_styles: 'Estilos Generales',
      answer_options: 'Opciones de Respuesta',
      redirect_button: 'Botón de Redireccionamiento',
      positive_button: 'Botón Positivo',
      positive_button_text: 'Texto del Botón Positivo',
      negative_button: 'Botón Negativo',
      negative_button_text: 'Texto del Botón Negativo',
      welcome_title: 'Título de Bienvenida',
      welcome_description: 'Descripción de Bienvenida',
      welcome_buttons: 'Botones de Bienvenida',
      welcome_active: 'Activar Paso de Bienvenida',
      next_button: 'Botón Próximo',
      question_description: 'Descripción de la Pregunta',
      question_description_placeholder: 'Descripción de la Llamada',
      question_title: 'Título de la pergunta',
      question_title_placeholder: 'Escribe aquí tu pregunta',
      all_steps: 'Todos los Pasos',
      mail_service: 'Servicios de Email',
      mail_service_text_area: 'Pega aquí el código HTML del formulario proporcionado por tu '
        + 'servicio de email',
      custom_html_form: 'Formulario HTML personalizado',
      redirect_by_mail_service: 'Redireccionar para el servicio de email',
      multiple_answers: 'Permitir más de una respuesta',
      add_other_option: 'Añadir opción "outra"',
      redirect_url: 'URL de redireccionamiento',
      auto_redirect: 'Redireccionamiento automático',
      required_response: 'Respuesta obligatoria',
      multiline_response: 'Respuesta en múltiples lineas',
      multiple_choice_placeholder: 'Escribe aquí una opción de respuesta',
      add_option: 'Agregar opción',
      button_text: 'Texto del Botón',
      start_button_text: 'Texto del Botón Iniciar',
      next_button_text: 'Texto del Botón Próximo',
      you_are_editing: 'Está editando el',
      external_button: 'BOTÓN EXTERNO',
      click_button: 'Haz clic en el botón',
      copy_the: 'Pega el',
      box_code: 'código del Formulário de Búsqueda',
      call_button_code: 'código del botón de llamada',
      past_in_your_page: ' y pega en tu página',
      add_to_link_or_button: 'y añade el link o botón que abrirá el Formulário de Búsqueda',
      see_flow: 'Ver Flujo',
      first_value_welcome_select: 'Sí o No',
      second_value_welcome_select: 'Iniciar',
    },
    sidebar: {
      interval_until_action: 'Exhibir en intervalo de tiempo hasta que el visitante '
        + 'realice la acción',
      times_until_action: 'Exhibir limitadas veces hasta que el visitante realice la acción',
      until_action: 'Exhibir hasta que el visitante realice la acción',
      display_frequency: 'Frecuencia de Exhibición',
      when_box_should_display: '¿Cuándo el Formulário de Búsqueda debe aparecer?',
      exibition_mode: 'Modo de exhibición',
      how_box_should_display: `¿En que momento el Formulário de Búsqueda debe aparecer para
      tu visitante?`,
      when_leave_the_page: 'Al salir de la página',
      immediately_when_access: 'Inmediatamente al ingresar',
      on_scroll: 'En el desplazamiento',
      until_page_top: 'Hasta el comienzo de página (25%)',
      until_page_middle: 'Hasta el medio de la página (50%)',
      until_page_bottom: 'Hasta el final de la página (75%)',
      by_time_on_page: 'Por tiempo en la página',
      call_button_style: 'Estilo del Botón de Llamada',
      background_color: 'Color de Fondo',
      border_color: 'Color del Borde',
      border_radius: 'Redondeo',
      text_color: 'Color del texto',
      visibility: 'Visibilidad',
      font: 'Fuente',
      font_size: 'Tamaño del texto',
      height: 'Altura',
      width: 'Anchura',
      add_jump: 'Añadir Salto',
      add_answer: 'Añadir respuesta',
      select_destiny: 'Selecciona un destino',
      all_other_cases: 'En todos los otros casos ir para...',
      always_jump_to: 'Siempre Saltar para...',
      select_one_answer: 'Selecciona una respuesta',
      select_the_answers: 'Selecciona las respuestas',
      choose_one_answer: 'Elige una respuesta',
      go_to_next: 'Ir para el próximo',
      add_one_question: 'añade UNA cuestión haciendo CLIC EN ESTE BOTÓN',
      question: 'pregunta',
      yes_no: 'sí/no',
      text: 'texto',
      capture: 'Captura',
      of_email: 'de e-mail',
      redirec: 'REDIRECCIO',
      tion: 'NAMIENTO',
      format: 'Formato',
      choose_a_theme: 'ELIGE UN MODELO',
      edit_theme: 'Editar tema',
      without_style: 'Sin Estilo',
      alignment: 'Alineación',
      call_button: 'Botón de Llamada',
      in_one_component: 'En un componente',
      one_component_to_integrate: 'Un componente para integrar en tu página',
      in_full_screen: 'En pantalla entera',
      one_screen_that_cover: 'Una pantalla cubre tu página completamente',
      in_mini_slider: 'En un mini slide',
      one_small_window_apper: 'Una pequeña ventana surge en el margen inferior de la página',
      in_a_popup: 'En un pop-up',
      one_box_apper_in_the_middle: 'Una caja surge en el medio de la pantalla',
      in_a_slider: 'En un slide',
      one_screen_apper_right: 'Una pantalla que surge del lado derecho',
      how_might_show: '¿Cómo deseas exhibir?',
      select_box_format: 'Selecciona el formato de tu Formulário de Búsqueda',
      auto: 'Automáticamente',
      at_some_point: 'En algún momento durante el acceso',
      on_click: 'Al hacer clic',
      on_click_some_button: 'Al hacer clic en algún botón dentro de la página',
      when_might_show: '¿Cuándo deseas exhibir?',
      select_when_box_should_apper: 'Selecciona cuando el Formulário de Búsqueda debe aparecer',
      configure_box: 'Configurar el Formulário de Búsqueda',
    },
  },
  step_kinds: {
    kinds: {
      multiple_choise: {
        title: '¿Cuál es tu pregunta?',
        description_text: 'Descripción de la pregunta',
      },
      yes_no: {
        title: '¿Cuál es tu pregunta?',
        description_text: 'Descripción de la pregunta',
      },
      text: {
        title: '¿Cuál es tu nombre?',
        description_text: '',
        placeholder: 'Escribe aquí tu nombre...',
      },
      email: {
        title: '¿Cuál es tu email?',
        description_text: '',
      },
      redirect: {
        title: '¡Felicitaciones! Haz clic aquí para acceder a tu contenido personalizado',
        description_text: '',
        button_text: 'Acceder la página',
      },
      thanks: {
        title: '¡Gracias!',
        description_text: '¡Tus datos han sido computados con éxito en nuestra encuesta!',
      },
    },
    options: {
      multiple_choise: {
        first_option: 'Opción 1',
        second_option: 'Opción 2',
      },
      yes_no: {
        yes: 'Sí',
        no: 'No',
      },
    },
  },
  notifications: {
    noNotifications: 'No hay notificaciones nuevas.',
    unableLoad: 'No pudimos cargar notificaciones en este momento.',
  },
  empty: {
    title: 'Crea formularios para conocer mejor a tus clientes y captar contactos',
    subtitle: `Puede realizar encuestas que lo ayudarán a comprender a su audiencia.
               Al final del formulario, reúna los clientes potenciales
               (contactos) de las personas que responderán.`,
    link: 'Obtenga información sobre los formatos de formulario que puede crear',
    button: 'Crear formulario',
    url: 'https://suporteklickpages.zendesk.com/hc/pt-br/articles/4587915332109-Conhecendo-o-Klickbox',
    urlExtensions: 'https://suporteklickpages.zendesk.com/hc/pt-br/articles/4587915332109-Conhecendo-o-Klickbox',
  },
};



/** WEBPACK FOOTER **
 ** ./src/i18n/messages/languages/es.js
 **/